import { handleTileVisibility, onFilterButtonClick, onFilterSelectChange } from './modules/events';
import { classes, filterChangeEventName, selectors } from './modules/lib';

const initFilterSelect = (nav, urlHashValue) => {
	const select = nav.querySelector(selectors.filterSelect);
	if (!select) {
		return;
	}

	if (urlHashValue) {
		const targetFilterElement = nav.querySelector(`${selectors.filterSelect} option[value="${urlHashValue}"]`);
		if (targetFilterElement) {
			select.value = urlHashValue;
		}
	}

	// Dispatch a change event to show the correct tiles on page load
	select.dispatchEvent(new Event('change'));
};

const initFilterButtons = (nav, urlHashValue) => {
	const filterButtons = nav.querySelectorAll(selectors.filterButton);
	if (!filterButtons.length) {
		return;
	}

	const targetFilterElement = nav.querySelector(`${selectors.filterButton}[data-cat="${urlHashValue}"]`);
	if (urlHashValue && targetFilterElement) {
		!targetFilterElement.classList.contains(classes.active) && targetFilterElement.click();
	} else {
		// If one filter element is always on or the first filter element should be preselected, the first filter element is clicked.
		if ([classes.filterSelectFirst, classes.filterAlwaysOn].some((className) => nav.classList.contains(className))) {
			nav.querySelector(selectors.filterButton)?.click();
		}
	}
};

document.querySelectorAll(selectors.filterNavigation).forEach((nav) => {
	/**
	 * Add the event listeners
	 */

	// Add the filter change event listener to the filter navigation element
	nav.addEventListener(filterChangeEventName, (e) => {
		handleTileVisibility(nav.nextElementSibling, e.detail.filterValue);
	});

	// Mobile Control: Add the change event listener to the select element
	nav.querySelector(selectors.filterSelect)?.addEventListener('change', onFilterSelectChange);

	// Desktop Control: Add the click event listener to every filter button
	nav.querySelectorAll(selectors.filterButton).forEach((filterEl) => filterEl.addEventListener('click', onFilterButtonClick));

	/**
	 * Initialize the filter control elements
	 */

	// Extract the hash value from the URL
	// ? Is there a better way instead of using the hash?
	const hashValue = window.location.hash.replace('#', '');

	initFilterSelect(nav, hashValue);
	initFilterButtons(nav, hashValue);
});
